import { useContext } from "react";
import { AppContext } from "@ctx/AppContexts";
import type { AppContextType } from "@/types";

export const useAppContext = (): AppContextType => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useAppContext must be used within AppProvider");
  return ctx;
};
